/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { hashHistory,withRouter } from 'react-router';
import {Icon, Button, Menu, Dropdown,message} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {dictionaryStore,dictionaryActions} from './store';
import {dictionayList,dictionayDelete,dictionayModify} from '../../service/dictionary';



class DictionaryList extends Reflux.Component {
	constructor(props) {
		super(props);
		this.store = Reflux.initStore(dictionaryStore); //创建一个Store实例;
		this.state = {
			rows: [],
			total: 0,
			opts: ['数据字典'],
			key: 0,
			filterBoxVisible: false,
			selectedKeys:[],
			dicObj:{
				sKey: '',
				name: '',
				active:null,
				p:1,
				s:10
			}
		};

		this.pageChange = this.pageChange.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.dropdownClick = this.dropdownClick.bind(this);
		this.goView=this.goView.bind(this);
		this.getData=this.getData.bind(this);
		this.routeLeaveHook=this.routeLeaveHook.bind(this);
	}

	//离开当前路由时，更新store
	routeLeaveHook(nextLocation) {
		const {dicObj} =this.state;
		let path = nextLocation.pathname.split('/');
		if(path[1] === 'dictionary' && path[2] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
			dictionaryActions.useStoreChange(true);
			dictionaryActions.paramChange(dicObj);
		}else{
			dictionaryActions.useStoreChange(false);
			dictionaryActions.paramChange({});
		}
	}

	componentWillMount () {
		const data = this.store.state;
		if (data.useStore) { //根据useStore的值判断是否使用store中的数据
			this.setState({
				dicObj:data.searchObj
			});
		}
	}

	componentDidMount(){
		this.getData();
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}

	getData(){
		var obj=this.state.dicObj;
		dictionayList(obj).then(result => {
			if(result.status){
				let list = result.data;
				this.setState({
					rows: list,
					total:result.total
				});
			}else{
				message.error(result.message);
			}

		})
	}

	//页面跳转
	goView (url) {
		hashHistory.push(url);
	}

	visibleChange() {
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible
		})
	}

	advanceReset() {
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			dicObj: {
				...this.state.dicObj,
				sKey: '',
				name: '',
				active:null,
				p:1,
			}
		}, () => {
			self.getData();
		});
	};

	advanceSubmit(form) {
		var subObj=this.state.dicObj;
		subObj.p=1;
		subObj.active =subObj.active|| null;
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			dicObj: subObj}, function () {
			self.getData();
		});
	};

	setFilterParam(name, value) {
		this.setState({dicObj: {...this.state.dicObj, [name]: value}})
	};

	pageChange(page, pageSize) {
		const self = this;
		this.setState({ dicObj: { ...this.state.dicObj, s: pageSize, p: page } }, function () {
			self.getData();
		});
	}

	onVisibleChange(visible){
		this.setState({
			selectedKeys:[]
		});
	}

	dropdownClick({item, key, keyPath}) {
		const {selectedKeys} =this.state;
		selectedKeys.push(key);
		this.setState({
			selectedKeys
		});
		var arr = key.split('_');
		//失效
		if (arr[0] === '0') {
			var data = this.state.rows;
			if(data[arr[1]].active===1){
				data[arr[1]].active = 0;
			}else{
				data[arr[1]].active = 1;
			}
			dictionayModify(data[arr[1]]).then(result=>{
				if(result.status){
					message.success(result.message);
					this.getData();
				}else{
					message.error(result.message);
				}
			})
		}

		//删除
		if (arr[0] === '1') {
			var num=parseInt(this.state.rows[arr[1]].id,0);
			dictionayDelete(num).then(result=> {
				if(result.status){
					message.success(result.message);
					this.getData();
				}else{
					message.error(result.message);
				}
			})
		}
	}

	menu(index) {
		return <Menu style={{width: "100px", textAlign: 'center'}}
					 onClick={this.dropdownClick}
					 selectedKeys={this.state.selectedKeys}>
			<Menu.Item key={`0_${index}`}>
				{
					(this.state.rows[index].active === 1) ?
						'失效'
						:
						'有效'
				}
			</Menu.Item>
			<Menu.Item key={`1_${index}`}>
				删除
			</Menu.Item>
		</Menu>
	}

	render() {
		const {opts, filterBoxVisible, rows, total, dicObj} = this.state;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
					{
						name: 'sKey',
						label: '数据项Key',
						defaultValue:dicObj.sKey,
						text: '请输入数据项Key',
						type: 'default'
					},
					{
						name: 'name',
						label: '数据项名称',
						defaultValue:dicObj.name,
						text: '请输入数据项名称',
						type: 'default'
					},
					{
						name: 'active',
						label: '有效性',
						text: "请选择状态",
						defaultValue:(dicObj.active!=null)?dicObj.active.toString():'',
						options: [
							{value: '0', text: '无效'},
							{value: '1', text: '有效'},
							{value: '', text: '全部'}
						],
						type: 'select'
					}
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total,
				current: dicObj.p,//当前页码
				pageSize: dicObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [{
				title: '数据项Key',
				dataIndex: 'sKey',
				render: (text, record, index) => <a href={`#/dictionary/detail/${record.id}`}>{text}</a>
			}, {
				title: '数据项名称',
				dataIndex: 'name',
			}, {
				title: '类型',
				dataIndex: 'type',
				render: text => text === 1 ? <span>从属</span> :
					<span>独立</span>

			}, {
				title: '有效性',
				dataIndex: 'active',
				render: text => text === 1 ? <span style={{color: 'green'}}>有效</span> :
					<span style={{color: '#d61518'}}>无效</span>
			},
				{
					title: '更多操作',
					key: 'action',
          			className: 'alignCenter',
					render: (text, record, index) => (
						<Dropdown overlay={this.menu(index)}
								  placement='bottomCenter'
								  trigger={['click']}
								  onVisibleChange={this.onVisibleChange.bind(this)}>
							<span className="ant-dropdown-link">
								<Icon type="caret-down"/>
							</span>
						</Dropdown>
					)
				}],
			rows
		};
		return (
			<div className='dms-body'>
				<div>
					<DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
						<Button icon="plus" onClick={this.goView.bind(this, '/dictionary/add/0')}>新增</Button>
						<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
						<FilterBox  {...filterBoxProps}/>
					</DmsTab>
				</div>

				<div className="dms-table-box">
					<TableView {...tableViewProps} />
				</div>
			</div>
		)
	}
};
export default withRouter (DictionaryList);



// WEBPACK FOOTER //
// ./src/routes/dictionary/list.js